import { Flex, Heading, Stack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useUserStore } from '@/stores';
import { GestorSelect } from './GestorSelect';
import { PatientSearchInput } from './PatientSearchInput';

interface Props {
  title: string;
  search: string;
  onChange: any;
  typeGestor?: string;
  setTypeGestor?: any;
}

export function TopSectionGestor({
  title,
  search,
  onChange,
  typeGestor,
  setTypeGestor,
}: Props) {
  const user = useUserStore(state => state.user);

  return (
    <Flex
      direction={['column', 'column', 'row']}
      w="100%"
      align="center"
      justify="space-between"
    >
      <Heading
        size="lg"
        w="100%"
        mb={['4', '4', '0']}
        color="brand-dark.500"
        fontWeight="medium"
      >
        {title}
      </Heading>
      <Stack
        direction={['column', 'row']}
        spacing="4"
        w="100%"
        justify="flex-end"
      >
        {/* {user?.type === 'admin' && (
          <GestorSelect typeGestor={typeGestor} setTypeGestor={setTypeGestor} />
        )} */}
        <PatientSearchInput value={search} onChange={onChange} />
      </Stack>
    </Flex>
  );
}
